export default __webpack_public_path__ + "images/logoLeCleanse.1a3bc07345ff1ffa9edb4fa572d2f9ae.svg"